function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "app-store-square",
  d: "M28.031,23.952H26.4l.971,1.714a1.138,1.138,0,0,1-1.983,1.116l-1.6-2.83L22.506,21.68l-1.177-2.1a.635.635,0,0,1-.094-.154,2.094,2.094,0,0,1-.113-.2.011.011,0,0,0-.011-.011,3.364,3.364,0,0,1,.5-3.759L24.727,21l.392.682h2.912a1.136,1.136,0,1,1,0,2.272Zm-5.866,0H11.506a1.136,1.136,0,1,1,0-2.272H14.42l4.037-7.147v-.011l-1.125-1.994a1.137,1.137,0,1,1,1.983-1.114l.454.806.455-.806a1.137,1.137,0,1,1,1.983,1.114l-1.126,2-1.312,2.313L17.032,21.68H20.8A1.547,1.547,0,0,1,22.35,23.23a1.45,1.45,0,0,1-.185.722Zm-8.014,2.83a1.151,1.151,0,0,1-.992.579,1.136,1.136,0,0,1-.991-1.694l.64-1.136a2.56,2.56,0,0,1,2.282.6ZM27.5,5H12.038C7.77,5,5,7.768,5,12.038V27.5c0,4.268,2.77,7.038,7.038,7.038H27.5c4.269,0,7.038-2.77,7.038-7.038V12.038C34.537,7.768,31.769,5,27.5,5Z",
  transform: "translate(-5 -5)",
  fill: "#2a67f4"
});

function SvgIcAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.537,
    height: 29.537,
    viewBox: "0 0 29.537 29.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAppStore);
export default ForwardRef;